export function checkTariffBuyError(responseError) {
  let isOpenModal = false;

  if (
    responseError?.response?.status === 400 &&
    responseError?.response?.data?.message ===
      "distributor.representation_mismatch"
  ) {
    isOpenModal = true;
  }

  return isOpenModal;
}
